const getName = ({ firstName = '', lastName = '', userEmail = '' }) => {
  const name = `${firstName} ${lastName}`;
  return name !== ' ' ? name : userEmail;
};

export default {
  getName,
};
